module.exports = __webpack_public_path__ + "img/Carte_Confituur_mobile_social_media_instagram.ed54a6a4.png";